import { render, staticRenderFns } from "./DetailsContainer.vue?vue&type=template&id=b051a960&scoped=true&"
import script from "./DetailsContainer.vue?vue&type=script&lang=ts&"
export * from "./DetailsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsContainer.vue?vue&type=style&index=0&id=b051a960&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b051a960",
  null
  
)

export default component.exports